import styled from 'styled-components';

export const CreateUserStyled = styled.div`
  margin-top: 18px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  .form {
    max-width: 600px;

    & .form-inputs {
      display: grid;
      grid-template-columns: 1fr;
      gap: 20px;

      & .checkbox {
        display: flex;
        align-items: center;

        & p {
          font-size: 8.5px;

          @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
            font-size: 14px;
          }
        }
      }

      & .input-text {
        display: flex;
        flex-direction: column;
        gap: 8px;

        & .input {
          width: 100%;
          border: 1px solid ${({ theme }) => theme.colors.disableButtonText};
        }
      }
    }
  }
`;
